import axios from './CommonHttpRequest';
let baseUrl = `${process.env.REACT_APP_INVOICEMANAGER_API}`;

export const GetAllCurrencyList = async () => {
    return await axios.get(`${baseUrl}api/CurrencyMaster/GetCurrency`)     
}